export default __webpack_public_path__ + "b9f057baa6bb8bcaf78ec6486e2c92b1.png";